import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faEye} from '@fortawesome/pro-solid-svg-icons';
import {canToggleAssetVisibility, assetIsVisible} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionVisibleIcon = faEye;

/**
 * Make asset visible
 * @param params
 * @returns Action
 */
export const assetActionMakeVisible = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-visible',
	cb: () => dispatcher.trigger(ASSET_EVENT.MAKE_VISIBLE, asset),
	enableTest: () => canToggleAssetVisibility(asset) && !assetIsVisible(asset),
	icon: assetActionVisibleIcon,
	get label() {
		return AssetActionLabel.MAKE_VISIBLE;
	},
	...params,
});
